const parseLocation = value => {
  const loc = value.split(',').map(v => parseFloat(v));
  return {
    zoom: loc[0],
    center: [loc[1], loc[2]],
  };
};

/**
 * Parse a date string into a Date object.
 * @param {string} dateString The YYYY-MM-DD date string to parse (assumes UTC).
 */
function parseDate(dateString) {
  const [year, month, day] = dateString.split('-').map(v => parseInt(v));
  return new Date(Date.UTC(year, month - 1, day));
}

const parseDateRange = value => {
  const dates = value.split(',');
  return {
    startDate: parseDate(dates[0]),
    endDate: parseDate(dates[1]),
  };
};

const transformParam = (key, value) => {
  switch (key) {
    case 'loc':
      return parseLocation(value);
    case 'dates':
      return parseDateRange(value);
    case 'selected':
      return {[key]: parseInt(value)};
    default:
      return {[key]: value};
  }
};

export const parseExtraParams = params => {
  let extras = {};
  if (params[0]) {
    // split by the slash.
    // then map to array of
    params[0].split('/').forEach(keyPair => {
      const [key, value] = keyPair.split(/=(.+)/);
      const mixin = transformParam(key, value);
      extras = {
        ...extras,
        ...mixin,
      };
    });
  }

  return extras;
};

const formatLocation = value => {
  return `loc=${Math.floor(value.zoom)},${value.center[0].toFixed(
    5,
  )},${value.center[1].toFixed(5)}`;
};

/**
 * Format a date object into a YYYY-MM-DD (UTC) date string.
 * @param {Date} date The date to format.
 * @returns {string} The formatted date string.
 */
function formatDate(date) {
  return date.toISOString().split('T')[0];
}

const formatDateRange = value => {
  return `dates=${formatDate(value.startDate)},${formatDate(value.endDate)}`;
};

export const formatExtraParams = params => {
  const extras = [];
  for (const key in params) {
    const value = params[key];
    switch (key) {
      case 'loc':
        extras.push(formatLocation(value));
        break;
      case 'dates':
        extras.push(formatDateRange(value));
        break;
      default:
        extras.push(`${key}=${value}`);
    }
  }

  return extras.join('/');
};
